import styled from 'styled-components';
import { MENU_ITEM_HEIGHT } from '../../../../utils/styled/dimensions';
import AppCSS from '../../../../utils/styled';
import { ReactComponent as CheckIcon } from '../../../../assets/icons/icon-check-alt.svg';

export const Components = {
  Container: styled.div<{ isSelected: boolean }>`
    width: 100%;
    display: flex;
    padding: 8px;
    max-height: ${MENU_ITEM_HEIGHT}px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    ${({ isSelected }) => isSelected && `background-color: ${AppCSS.colors.greys.light};`};
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    cursor: pointer;
  `,
  AvatarWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `,
  Label: styled.span`
    ${AppCSS.fonts.h6};
    color: ${AppCSS.colors.black};
  `,
  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  Icon: styled(CheckIcon)`
    width: 16px;
    height: 16px;
  `,
};
